import * as ingredientActions from './ingredientActions'

import { Button } from '@atd/rui-base.mui.button'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { Checkbox } from '@atd/rui-base.mui.checkbox'
import { Table } from '@atd/rui-base.mui.table'
import { TableBody } from '@atd/rui-base.mui.table-body'
import { TableHead } from '@atd/rui-base.mui.table-head'
import { TableRow } from '@atd/rui-base.mui.table-row'
import { TableCell } from '@atd/rui-base.mui.table-cell'

import AddIcon from '@mui/icons-material/Add'
import DeleteButton from '../commonComponents/deleteDialogButton'
import EditIcon from '@mui/icons-material/Create'
import EmptyState from '../commonComponents/emptyState'
import IngredientEdit from './ingredientCreation'
import ListPaging from '../commonComponents/listPaging'
import ProductLoader from './productLoader'
import React from 'react'
import TableRowColumnWrapper from '../commonComponents/tableRowColumnWrapper'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ingredientPrototype } from './productPrototypes'

function mapStateToProps(state, ownProps) {
    // Users are only allowed to manage/edit mixes that belong to their company
    // not universal mixes like water
    const ingredientProps = state.product.ingredients || []

    return {
        isLoading: ingredientProps.isLoading,
        error: ingredientProps.error,
        ingredients: ingredientProps.data.filter(m => m.ownerPartyId == state.admin.selectedCompanyId),
        selectedCompanyId: state.admin.selectedCompanyId,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(ingredientActions, dispatch),
    }
}

class IngredientManager extends React.Component {
    state = {
        editIngredientId: null,
        newIngredientOpen: false,
        selectedIngredients: [],
        viewList: [],
        startViewIndex: 0,
        lastViewIndex: 0,
    }

    componentDidMount() {
        this.props.fetchIngredients()
    }
    getDisabled = () => {
        return !this.props.selectedCompanyId
    }
    editIngredientRequest = (id) => {
        this.setState({editIngredientId: id})
    }
    onEditIngredientCancel = () => {
        this.setState({editIngredientId: null, newIngredientOpen: false})
    }
    onEditIngredientSave = (newIngredientData) => {
        this.props.updateIngredient(newIngredientData)
        this.setState({editIngredientId: null, selectedIngredients: []})
    }
    newIngredientRequest = () => {
        this.setState({ newIngredientOpen: true })
    }
    onNewIngredientSave = (newData) => {
        this.props.addIngredient(newData)
        this.setState({ newIngredientOpen: false, selectedIngredients: []})
    }
    onIngredientDelete = () => {
        this.props.deleteIngredients(this.state.selectedIngredients).then(rVal => {
            if (rVal && !rVal.error) {
                this.setState({selectedIngredients: []})
            }
        })
    }
    onViewListChanged = (newList, startIndex, lastIndex) => {
        this.setState({
            viewList: [...newList],
            startViewIndex: startIndex,
            lastViewIndex: lastIndex,
        })
    }

    toggleIngredient = (id) => {
        this.setState(prev => ({
            selectedIngredients: prev.selectedIngredients.includes(id) ? prev.selectedIngredients.filter(i => i !== id) : [...prev.selectedIngredients, id],
        }))
    }
    toggleAllIngredients = (checked) => {
        const viewIds = this.state.viewList.map(ing => ing.id)
        this.setState(prev => {
            const others = prev.selectedIngredients.filter(id => !viewIds.includes(id))

            return { selectedIngredients: checked ? [...others, ...viewIds] : others }
        })
    }
    mapIngredientsToTableRows = (ingredient, index) => {
        return (
            <TableRow
                key={ingredient.id}
                selected={this.state.selectedIngredients.includes(ingredient.id)}
                name={ingredient.id}
                hover
                onClick={() => { if (!this.getDisabled()) this.toggleIngredient(ingredient.id) }}
                sx={{ cursor: this.getDisabled() ? 'default' : 'pointer' }}
            >
                <TableCell padding="checkbox" sx={{ pl: 0, width: 'auto' }} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        size="small"
                        sx={{ p: 0.25 }}
                        checked={this.state.selectedIngredients.includes(ingredient.id)}
                        disabled={this.getDisabled()}
                        onChange={() => this.toggleIngredient(ingredient.id)}
                        name={`select-${ingredient.id}`}
                    />
                </TableCell>
                <TableCell className="pmColumn">{ingredient.name}</TableCell>
                <TableCell className="pmColumn">
                    {ingredient.manufacturer ? ingredient.manufacturer : ''}
                </TableCell>
                <TableCell className="pmColumn">
                    {ingredient.typeId ? ingredient.typeId : ''}
                </TableCell>
                <TableRowColumnWrapper className="pmColumn">
                    <IconButton
                        disabled={this.getDisabled()}
                        onClick={() => { this.editIngredientRequest(ingredient.id) }}
                        name={`edit-${ingredient.id}`}><EditIcon htmlColor={this.getDisabled() ? '#bdbdbd' : '#006495'} />
                    </IconButton>
                </TableRowColumnWrapper>
            </TableRow>
        )
    }
    renderIngredientEdit = () => {
        if (!this.state.editIngredientId && !this.state.newIngredientOpen) return
        let ingredient

        if (this.state.editIngredientId) {
            ingredient = this.props.ingredients.find(element => {
                return element.id === this.state.editIngredientId
            })
        }
        else {
            ingredient = new ingredientPrototype('')
        }

        return (
            <IngredientEdit
                open={true}
                data={ingredient}
                onSave={this.state.editIngredientId ? this.onEditIngredientSave : this.onNewIngredientSave}
                onCancel={this.onEditIngredientCancel}
            />
        )
    }
    render() {
        const ingredientRows = this.state.viewList.map(this.mapIngredientsToTableRows)
        const ingredientEdit = this.renderIngredientEdit()
        const viewIds = this.state.viewList.map(ing => ing.id)
        const allChecked = viewIds.length > 0 && viewIds.every(id => this.state.selectedIngredients.includes(id))
        const someChecked = !allChecked && viewIds.some(id => this.state.selectedIngredients.includes(id))

        if (this.props.isLoading && !this.props.error) {
            return (
                <ProductLoader />
            )
        }

        if (!this.props.isLoading && this.props.error) {
            return (
                <div style={{paddingTop: '40px', textAlign: 'center'}} >
                    <h3>{this.props.error}</h3>
                </div>
            )
        }

        if (!this.props.isLoading && !this.props.error && !this.props.ingredients.length) {

            return (
                <EmptyState>
                    <div style={{paddingTop: '40px'}} >
                        <h3>No ingredients found</h3>
                        <div style={{margin: '20px 0'}}>
                            <Button variant="contained"
                                onClick={this.newIngredientRequest}
                                startIcon={<AddIcon htmlColor="white"/>}
                                color="primary"
                                fullWidth={false}>Create Ingredient</Button>
                        </div>
                        {ingredientEdit}
                    </div>
                </EmptyState>
            )
        }

        return (
            <div>
                <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 10}}>
                    <Button variant="contained"
                        color="primary"
                        startIcon={<AddIcon htmlColor="white" />}
                        disabled={this.getDisabled()}
                        onClick={this.newIngredientRequest}
                        name="addIngredient"
                        style={{marginRight: 10}}>Add Ingredient</Button>
                    <DeleteButton
                        itemType="ingredient"
                        deleteFunction={this.onIngredientDelete}
                        primary={true}
                        disabled={!this.state.selectedIngredients.length || this.getDisabled()}
                        customContent={'Are you sure you wish to delete these ingredients? This will not affect current mixes or generated jobs'}
                        flat={false}
                    />
                </div>
                <Table
                    className="pmTable"
                    style={{ tableLayout: 'auto', whiteSpace: 'normal' }}
                    name="pmTable"
                >
                    <TableHead >
                        <TableRow>
                            <TableCell padding="checkbox" sx={{ pl: 0, width: 'auto' }}>
                                <Checkbox
                                    size="small"
                                    sx={{ p: 0.25 }}
                                    checked={allChecked}
                                    indeterminate={someChecked}
                                    disabled={this.getDisabled()}
                                    onChange={(e) => this.toggleAllIngredients(e.target.checked)}
                                    name="selectAllIngredients"
                                />
                            </TableCell>
                            <TableCell className="pmColumn">{'Name'}</TableCell>
                            <TableCell className="pmColumn">{'Manufacturer'}</TableCell>
                            <TableCell className="pmColumn">{'Type'}</TableCell>
                            <TableCell className="pmColumn">{''}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {ingredientRows}
                    </TableBody>
                </Table>
                <ListPaging
                    countPerPage={15}
                    disabled={this.getDisabled()}
                    itemList={this.props.ingredients}
                    viewListChanged={this.onViewListChanged}
                />
                {ingredientEdit}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IngredientManager)
